<template>
  <div
    class="card-section section"
    :class="color"
  >
    <div class="title-line line">
      <h2 class="title-strat">{{ title }}</h2>
      <NuxtLink
        :to="ctaRoute"
        class="button-more"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19.328 34.43"
        >
          <path
            d="M18.71 15.72 3.66.62a2.178 2.178 0 0 0-3.041 0 2.178 2.178 0 0 0 0 3.041l13.555 13.555L.619 30.77a2.178 2.178 0 0 0 0 3.041 2.178 2.178 0 0 0 3.041 0l15.05-15.05a2.178 2.178 0 0 0 0-3.041Z"
            fill="#fff"
            fill-rule="evenodd"
          />
        </svg>
        <h3>{{ ctaLabel }}</h3>
      </NuxtLink>
    </div>
    <div class="slider">
      <CardSlider :cards="cards" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cards?: Record<string, any>[]
    ctaRoute?: string
    ctaLabel?: string
    title?: string
    color?: string
  }>(),
  {
    cards: () => [],
    ctaRoute: '',
    ctaLabel: '',
    title: '',
    color: '',
  },
)
</script>

<style lang="scss" scoped>
@media screen and (max-width: 430px) {
  .card-section .title-line {
    .title-strat {
      font-size: 1.2rem;
      letter-spacing: 0.15rem;
    }
  }
}
</style>
